import { render, staticRenderFns } from "./EventsTopFundraisers.vue?vue&type=template&id=4c57841f&lang=html&"
import script from "./EventsTopFundraisers.vue?vue&type=script&lang=js&"
export * from "./EventsTopFundraisers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports